import type { AgentGardenAgentAPI, AgentMode } from '../types/agent';
import { fetchAndParse } from '../utils/ajax';
import { getTenantId } from '../utils/tenant';

export const getAllAgents = (
    accountId: string,
    name: string | null,
    agentMode: AgentMode | null,
) => {
    const url = `/api/draw/1/agent/${accountId}`;
    const query = new URLSearchParams();

    if (name) {
        query.set('name', name);
    }

    if (agentMode) {
        query.set('agentMode', agentMode);
    }

    return fetchAndParse<AgentGardenAgentAPI[]>({
        url: `${url}?${query.toString()}`,
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
};

export const getAgent = (accountId: string, id: string | null) => {
    const url = `/api/draw/1/agent/${accountId}/${id}`;

    return fetchAndParse<AgentGardenAgentAPI>({
        url,
        headers: {
            ManyWhoTenant: getTenantId(),
        },
    });
};
